var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-time-picker',_vm._g(_vm._b({model:{value:(_vm.timeRange),callback:function ($$v) {_vm.timeRange=$$v},expression:"timeRange"}},'el-time-picker',{..._vm.$props, ..._vm.$attrs},false),_vm.$listeners)),(_vm.showDuration)?_c('div',{staticClass:"explain-text"},[_vm._v("时长: "+_vm._s(_vm.duration))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }